import { DefaultAvatarColors, } from '../theme/theme-base';
export const getAvatarColor = (project = 'lxp') => {
    const defaultColors = DefaultAvatarColors;
    const randomIndex = Math.floor(Math.random() * defaultColors.length);
    const item = defaultColors[randomIndex];
    return item;
};
//# sourceMappingURL=avatar-randomizer.js.map